import { render } from "./AppMenu.vue?vue&type=template&id=0ad11b28&ts=true"
import script from "./AppMenu.vue?vue&type=script&lang=ts"
export * from "./AppMenu.vue?vue&type=script&lang=ts"

import "./AppMenu.vue?vue&type=style&index=0&id=0ad11b28&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__